import type { FC, PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from '@/lib/i18n/i18n.ts';

const I18nLoader: FC<PropsWithChildren> = ({ children }) => (
  <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
);

export default I18nLoader;
